export const createGradient = (color: {
  default: string;
  half: string;
  quarter: string;
  zero: string;
}) => {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  if (!ctx) return color.default;

  const gradient = ctx.createLinearGradient(0, 0, 0, 250);
  gradient.addColorStop(0, color.half);
  gradient.addColorStop(0.35, color.quarter);
  gradient.addColorStop(1, color.zero);

  return gradient;
};
